// Human-readable subtext for the "Select Dataset" step.
//
// The sections API does not expose a description field, so the short blurbs
// below live in the frontend. `parentModuleDescriptions` is keyed by a
// section's `parent_module` (the group heading) and `datasetDescriptions` is
// keyed by a section's `abbreviation` (an individual dataset card). Both look
// ups fall back to an empty string, so unknown modules / datasets simply render
// without subtext rather than breaking the picker.

const parentModuleDescriptions = {
  'Accounts Payable':
    'Invoices, payments, and disbursements processed through accounts payable.',
  Purchasing:
    'Purchase orders and requisitions across the procurement lifecycle.',
  'General Ledger':
    'Journal entries and account activity recorded in the general ledger.',
  PCard: 'Purchasing card spend, broken out by cardholder and transaction.',
  Contracts: 'Contract records, terms, and associated spend commitments.',
  Vendor: 'Vendor master records and related risk signals.',
  Payroll: 'Employee earnings, pay runs, and payroll disbursements.',
  Budget: 'Budget appropriations and period-over-period spend.',
  Workflow: 'Approval workflows and pending approval activity.',
  Grants: 'Grant awards, expenditures, and compliance activity.',
  'Utility Billing':
    'Customer utility accounts, billing, adjustments, and metered consumption.'
}

const datasetDescriptions = {
  AP: 'Vendor invoices and the payments that clear them.',
  APLI: 'Line-item detail behind each accounts payable invoice.',
  GL: 'General ledger journal entries and account balances.',
  PO: 'Purchase orders issued to vendors.',
  RQ: 'Requisitions requesting goods and services.',
  PC: 'Purchasing card transactions.',
  CH: 'Purchasing card activity summarized by cardholder.',
  Vendor: 'Vendor master records and onboarding details.',
  VO: 'Vendor records with a focus on payment activity.',
  PR: 'Payroll runs and employee earnings.',
  BG: 'View every account with actuals, budget, encumbrances, and available balance.',
  BOT: 'Budget-to-actual spend tracked over each period.',
  WF: 'Completed approval workflow activity.',
  PWF: 'Approvals still pending in the workflow queue.',
  OKGT: 'Grant awards and expenditures.',
  CT: 'Contract records, terms, and commitments.',
  UBAccounts: 'Utility billing customer accounts and their status.',
  UBAdjustments: 'Manual adjustments applied to utility bills.',
  UBBilling: 'Utility bills issued to customer accounts.',
  UBConsumption: 'Metered utility consumption readings.'
}

export const getParentModuleDescription = (parentModule) =>
  parentModuleDescriptions[parentModule] || ''

export const getDatasetDescription = (abbreviation) =>
  datasetDescriptions[abbreviation] || ''
